
import React, { useEffect, useState } from 'react'

import AuthLayout from 'pages/auth/authlayout/authlayout'
import styles from './login.module.scss'
import { ERCText } from 'components/text'
import ERCInput from 'components/Input'
import { MdOutlineErrorOutline } from "react-icons/md";
import { ERCForm } from 'components/form'
import { useDispatch } from 'react-redux'
import { showModal } from 'store/reducers/modal'
// import { ERCButton } from 'components/button'
import ForgotPasswordModal from 'components/modal/forgotpassword' 
import * as Yup from 'yup';
import { toast } from 'react-toastify' 
import { setUser } from 'store/reducers/user'
import { useNavigate, useLocation } from 'react-router-dom'


const StoreTeacherLogin = ({ userType, navigateTo}) => {
   
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const schema = Yup.object().shape({
        emailPhone: Yup.string().required(),
        password: Yup.string().required().min(8),
    })

   
    const handleSignUp = () => {
        navigate("../signup-teacher", {state: { from: "../store-login-teacher"}})
    }

    console.log(handleSignUp)
    return (
        <AuthLayout >
            <div className={styles.body}>
                <div className={styles.login}>
                    <div className={styles.logo}>
                        <img src={"https://res.cloudinary.com/dmrtylvtc/image/upload/v1716814039/ERC/erc_main_logo_nbljik.svg"} alt="logo" />
                    </div>
                    <div className={styles.welcome_back}>
                        <ERCText weight='700' size='30px'>Welcome Back!</ERCText>
                        <div className={styles.top_text}>
                            <span style={{ color: '#FFD600' }} ><MdOutlineErrorOutline size={20} /> </span>
                            <ERCText size='12px'>Continue your <span style={{ color: '#FFD600', fontWeight: '600' }}>Learning.</span> Enter your registered Information</ERCText>
                        </div>
                    </div>

                    <ERCForm
                    extraFields={{ userType }}
                        validationSchema={schema}
                        inputsContainer={'!w-[430px] justify-center flex flex-col gap-[24px]'}
                        className={'!w-[auto] justify-center items-center flex flex-col gap-[56px] '}
                        btnClass={'!w-[100%] !bg-[#FFD600] !text-[16px] !text-[#00296B]'}
                        btnText={'Sign In'}
                        method={'post'}
                        url={'/user/login'}
                        noToken
                        onSuccess={(res) => {
                            dispatch(setUser(res))
                            navigate(navigateTo)

                            if(res.data.token){
                                let token = res.data.token;
                                console.log(res.data.token, 'token')
                                const authObj = {
                                  email: res.data.details.email,
                                  name: res.data.details.firstName,
                                  roles: res.data.details.role,
                                  id: res.data.details.id
                              };
                              const authObjString = JSON.stringify(authObj);
                              console.log(authObjString, 'authObj');
                              window.sessionStorage.setItem('auth', JSON.stringify(authObj));
                              window.sessionStorage.setItem('token', JSON.stringify(token));
                              const auth = JSON.parse(window.sessionStorage.getItem('auth'));
                              console.log(auth, 'auth');
                              }
                        }}
                        onError={err => {
                            if (err?.response) {
                                console.log(err)
                                toast.error('Login details incorrect!')
                            }
                        }}
                    >

                        <div >
                            <ERCInput containerClass='w-[auto]' label='Email Address' name='emailPhone' placeholder='Enter your email address' />
                        </div>
                        <div>
                            <ERCInput containerClass='w-[auto]' label='Password' name='password' placeholder='Enter your password' />
                        </div>
                        <div className='flex justify-end' >
                            <ERCText isLink size='16px' color='#FFD600' onClick={() => dispatch(showModal({
                                content: (<ForgotPasswordModal />)
                            }))} >Forgot Password?</ERCText>
                        </div>

                    </ERCForm>

                    <div>
                        <ERCText size='15px' weight="600"> Don't have an Account? <span className={'text-[#FFD600] '} onClick={handleSignUp} style={{ cursor: 'pointer' }}> SIGN UP</span></ERCText>
                    </div>

                </div>
            </div>

        </AuthLayout>
    )
}


export default StoreTeacherLogin